export default "__VITE_ASSET__4qJHHa3L__"